import type { AnalysisRecipeChartConfig } from '@/types/analysisRecipe.types';

const SCALAR_CHART_COLUMN_KEYS = [
  'xAxis',
  'seriesSplit',
  'heatmapValueColumn',
  // Legacy chart config fields retained for persisted recipe compatibility.
  'category',
  'value',
  'valueColumn',
] as const;

const ARRAY_CHART_COLUMN_KEYS = [
  'yAxisColumns',
  'xAxisGroupColumns',
  'yAxisGroupColumns',
] as const;

/**
 * Maps only the chart config properties whose values are column keys.
 * Display labels and other arbitrary strings in the config are intentionally
 * left unchanged.
 */
export function mapAnalysisChartColumnReferences(
  config: AnalysisRecipeChartConfig,
  mapColumn: (column: string) => string,
): AnalysisRecipeChartConfig {
  const mapped: AnalysisRecipeChartConfig = { ...config };

  SCALAR_CHART_COLUMN_KEYS.forEach((key) => {
    const value = config[key];
    if (typeof value === 'string') mapped[key] = mapColumn(value);
  });
  ARRAY_CHART_COLUMN_KEYS.forEach((key) => {
    const value = config[key];
    if (Array.isArray(value)) {
      mapped[key] = value.map(mapColumn);
    }
  });

  return mapped;
}

export function analysisChartReferencesAny(
  config: AnalysisRecipeChartConfig,
  columns: Set<string>,
): boolean {
  let referencesColumn = false;
  mapAnalysisChartColumnReferences(config, (column) => {
    if (columns.has(column)) referencesColumn = true;
    return column;
  });
  return referencesColumn;
}
